import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

// Importar estilos de antd
import 'antd/dist/reset.css';

// Función para verificar actualizaciones periódicamente
const checkForUpdates = async () => {
  try {
    const metaResponse = await fetch('/meta.json?t=' + new Date().getTime());
    if (metaResponse.ok) {
      const meta = await metaResponse.json();
      const lastBuildDate = meta.buildDate;

      // Obtener última fecha almacenada
      const storedBuildDate = localStorage.getItem('appBuildDate');

      if (storedBuildDate && lastBuildDate > parseInt(storedBuildDate)) {
        console.log('Nueva versión detectada:', lastBuildDate);
        localStorage.setItem('appBuildDate', lastBuildDate);

        // Si hay un SW registrado, enviarle la nueva versión
        if (navigator.serviceWorker && navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage({
            type: 'SET_CACHE_VERSION',
            version: lastBuildDate
          });

          // Forzar actualización de SW
          const registrations = await navigator.serviceWorker.getRegistrations();
          for (const registration of registrations) {
            if (registration.waiting) {
              registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
          }

          // Recargar después de un breve retraso
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      } else if (!storedBuildDate) {
        // Primera carga - guardar fecha
        localStorage.setItem('appBuildDate', lastBuildDate);
      }
    }
  } catch (error) {
    console.error('Error verificando actualizaciones:', error);
  }
};

// Verificar actualizaciones al inicio
checkForUpdates();

// Verificar periódicamente actualizaciones (cada 15 minutos)
setInterval(checkForUpdates, 15 * 60 * 1000);

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <App />
);

// Registrar el service worker para habilitar capacidades offline
serviceWorker.register({
  onUpdate: (registration:any) => {
    const waitingServiceWorker = registration.waiting;
    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", (event:any) => {
        if (event.target.state === "activated") {
          console.log('Service Worker actualizado y activado');
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
